import store from 'config/store'
import { pathOr } from 'ramda'
import { broadcast } from 'utils/message'

export const playSoundNotification = async () => {
  const soundEnabled = pathOr(false, ['embed', 'configuration', 'theme', 'soundNotificationEnabled'], store.getState())
  const { chatOpen } = store.getState().view

  if (soundEnabled) {
    await broadcast({
      topic: 'play-host-notification',
      message: {
        chatOpen
      }
    })
  }
}
